import styled from "@emotion/styled/macro";
import { flexCenter, flexColumn } from "../../../../common/styles/combos.styles";
import { colors } from "../../../../common/styles/theme.styles";
import { keyframes } from "@emotion/react";

export const VaultPendingFilesActionsWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 14px;
    align-self: stretch;
`;

export const VaultPendingFilesInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
`;

export const VaultPendingSingleFileDescription = styled.div`
    color: var(--Main-Colors-Dark-Grey-1, #1A1B1D);
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 22px; /* 137.5% */
`;
const gradientMove = keyframes`
    0% {
        background-position: 0% center;
    }
    100% {
        background-position: -200% center;
    }
`;
export const VaultPendingSingleFileDescriptionEmpty = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 22px; /* 137.5% */

    height: 28px;
    display: flex;
    align-items: center;

    background: linear-gradient(90deg, #ACB1BB 0%, #4E5155 50%);
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${gradientMove} 2s linear infinite alternate;
`;


export const VaultPendingFilesModalBody = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 16px;
    gap: 32px;
    padding: 16px 108px;
    position: relative;
    flex: 1;
    max-height: calc(100% - 158px);
    overflow-y: auto;
`;

export const VaultPendingFilesBoxWrapper = styled.div`
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    align-items: flex-start;

    border-radius: 16px;
    border: 1px solid var(--Main-Colors-Grey-3, #DDE3EB);
    align-self: stretch;

    max-height: 265px;
    min-height: 94px;
    overflow-y: auto;
`;

export const VaultPendingFilesBoxHeader = styled.div`
    display: flex;
    padding: 4px 0px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    color: var(--Dark-Gray-2, #585D66);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;
`;

export const VaultPendingFileBox = styled.div`
    display: flex;
    height: 56px;
    flex-shrink: 0;

    padding: 0px 16px 0px 8px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    :not(:last-child) {
        border-bottom: 1px solid var(--Main-Colors-Light-Grey-2, #F1F3F5);
    }
`;

export const VaultPendingFileBoxDescriptionSizeWrapper = styled.div`
    display: flex;
    gap: 4px;

    color: var(--Dark-Gray-3, #9097A3);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;
`;

export const VaultPendingFileBoxDescriptionSizeWrapperDot = styled.div`
    ::before {
        content: '·';
        margin-right: 4px;
        width: 4px;
        display: inline-flex;
    }

    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const VaultPendingFileBoxFileIconTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

export const DocumentStatusIconWrapper = styled.div`
    ${flexCenter};
    svg{
        width: 16px;
        height: 16px;
    }
`;

export const DocumentIconWrapper = styled.div`
  width: 32px;
  height: 32px;
`;


export const DocumentDetailsWrapper = styled.div`
  ${flexColumn};
  flex:1;
  padding: 2.5px 0;
  overflow: hidden;
`;

export const DocumentTitle = styled.div`
  color: ${colors.darkGray1};
  font-family: Circular;
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 18px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DocumentSize = styled(DocumentTitle)`
  color: ${colors.darkGray3};
  font-size: 12px;
  font-weight: 450;
  line-height: 15px;
`;

export const DocumentStatusBadge = styled.div`
    display: flex;
    justify-content: flex-end;
    background-color: ${props => props.status ? props.status === 'Done' ? '#72E1AC' : props.status === 'Rejected' ? '#FF947C' : null : null};
    color: ${props => props.status && (props.status === 'Pending' || props.status === 'Processing') ? null : '#fff'};
    box-shadow: 0px 1.23288px 2.46575px rgba(255, 255, 255, 0.04), 0px 0px 1.23288px rgba(255, 255, 255, 0.16);
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    padding: ${props => props.status && (props.status === 'Pending' || props.status === 'Processing') ? '0' : '4px 8px'};
    border-radius: 4px;
    margin-bottom:4px;
    gap: 4px;
    flex-shrink: 0;
`;

export const VaultPendingFilesActionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    flex: 1 0 0;
`;

export const VaultPendingFilesActionTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const VaultPendingFilesActionButtonsGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    animation: ${fadeIn} 0.3s ease-in;
`;

export const VaultPendingFilesActionButton = styled.div`
    display: flex;
    height: 36px;
    padding: 6px 0px;
    align-items: center;
    gap: 12px;
    border-radius: 10px;
`;

export const VaultPendingFilesActionButtonCheckmark = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    
    border-radius: 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.16);


    ${({ disabled }) => disabled && `
        border-radius: 5.4px;
        background: var(--Main-Colors-Light-Grey-2, #F1F3F5);
        box-shadow: 0px 2.25px 4.5px 0px rgba(0, 0, 0, 0.04), 0px 0px 2.25px 0px rgba(0, 0, 0, 0.16);

    `}

    
    ${({ checked, disabled }) => checked ? `
        background: var(--Dark-Gray-1, #1A1B1D);
        
    ${disabled && `
        background: var(--Main-Colors-Light-Grey-2, #F1F3F5);
        box-shadow: 0px 2.25px 4.5px 0px rgba(0, 0, 0, 0.04), 0px 0px 2.25px 0px rgba(0, 0, 0, 0.16);

        svg {
            path {
                stroke: #9097A3;
            }
        }
    
        `}

    ` : `
        flex-shrink: 0;
        border: 1px solid var(--Main-Colors-Grey-3, #DDE3EB);
        background: var(--White, #FFF);
    `}
`;

export const VaultPendingFilesActionButtonTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;

    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    user-select: none;

    strong {
        font-weight: 700;
    }
`;

export const VaultPendingFilesActionButtonTextSub = styled.div`
    color: #585D66;
    font-size: 12px;
`;

export const VaultPendingFilesUploadingModalFooter = styled.div`
    display: inline-flex;
    padding: 33px 37px 23px 24px;
    align-items: center;

    border-top: 1px solid var(--Gray-3, #DDE3EB);
    background: var(--White, #FFF);

    width: 100%;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
`;

export const VaultPendingFilesUploadingModalFooterButton = styled.div`
    display: flex;
    height: 44px;
    padding: 0px 32px;
    justify-content: center;
    align-items: center;
    gap: 2px;

    border-radius: 8px;
    background: var(--Dark-Gray-1, #1A1B1D);

    /* Tags Shadow */
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25), 0px 0.5px 4px 0px rgba(0, 0, 0, 0.08);

    color: var(--White, #FFF);
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    min-width: 150px;
    user-select: none;

    :hover {
        background: var(--Dark-Gray-1, #2B2C2E);
    }

    ${({ isDeleting }) => isDeleting && `
        opacity: 0.4;
    `}

    ${({ isButtonDisabled }) => isButtonDisabled ? `
        pointer-events: none;
        opacity: 0.4;
    ` : `
        cursor: pointer;
    `}
`;

export const VaultFilesBoxEndIcons = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;

    color: var(--White, #FFF);
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 130%; /* 18.2px */
`;

export const VaultFilesEndTag = styled.div`
    display: flex;
    height: 18px;
    padding: 5px 8px 6px 6px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    
    background: ${props => props.bgColor};

    border-radius: 6px;
`;



